import styled, { css } from 'styled-components';
import Colours from '/shared/styled/Colours';

interface Props {
  $white?: boolean;
  $small?: boolean;
}

function whiteStyle({ $white = false }: Props) {
  if ($white) {
    return css`
      color: ${Colours.white};
    `;
  }
  return css`
    color: ${Colours.black};
  `;
}

function smallStyle({ $small = false }: Props) {
  if ($small) {
    return css`
      font-size: 12px;
    `;
  }
}

export default styled.div<Props>`
  margin: 0;
  padding: 0;
  line-height: 1.8;

  &:not(:last-of-type) {
    margin-bottom: 1rem;
  }

  ${whiteStyle}
  ${smallStyle}
`;
